import { useEffect } from "react";
import AllPlayers from "./allPlayers";

const AllPlayersWrapper = () => {
  return <AllPlayers />;
};
export default AllPlayersWrapper;
